/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: constants.ts
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  30.09.22 2:31 pm.
 * Last modified: 30.09.22 2:31 pm.
 *
 * More information at: https://egt-digital.com/
 */

import { SoundSpriteDefinitions } from 'howler';

export const SEARCH_SECTION_NAME = 'SEARCH';
export const FETCH_JP_STAT_INTERVAL_SECONDS: number = 10; // keep this above 8 as server has threshold on updating values
export const FETCH_GAMES_CURRENT_PLAYER_STAT_INTERVAL_SECONDS: number = 60; // 1min
export const JP_STAT_UPDATE_FPS: number = 20;
export const LOCAL_STORAGE_FAVORITE_KEY = 'favourite';
export const LOBBY_SECTION_NAME = 'LOBBY';
export const LAST_PLAYED_SECTION_NAME = 'LAST_PLAYED';
export const LAST_PLAYED_STORAGE_KEY = 'egtd_last_played';
export const FAVORITE_SECTION_NAME = 'FAVORITES';
export const FAVORITE_SECTION_TAB_NAME = 'FAVORITES_TAB';
export const SCROLL_POS_STORAGE_KEY = 'egtd_lobby_scroll_possitions';
export const X_RIDE_MP = 'XRideMP';
export const MOST_PLAYED_SECTION_NAME = 'MOST_PLAYED';
// @ts-ignore
export const WEBPACK_HASH = String(__webpack_hash__);

export const soundSprites: SoundSpriteDefinitions = {
    exitAppSound: [0, 716.235827664399],
    hoverSound: [1500, 109.50113378684811],
    selectGameSound: [3000, 798.3446712018143],
    selectTabSound: [4500, 328.48072562358243],
    silent: [6000, 342.1541950113376],
};

export const BrandedTournamentImagesMap = {
    default: {
        bg: '/assets/portal/group_tournament/default/bg.png',
        en: '/assets/portal/group_tournament/default/en.png',
        default: '/assets/portal/group_tournament/default/en.png',
    },
};

export const BrandedStaticImagesMap = {
    progressive: {
        default: {
            default: '/assets/portal/group_progressive/default/logo.png',
        },
    },
};

/** array containing all games with support for animated banners */
export const gamesWithAnimatedBanners: string[] = [];

export const sectionsWithBgImages = [
    'high_cash',
    'vip_high_cash',
    'bell_link',
    'vip_bell_link',
    'clover_chance',
    'mystery',
    'progressive',
    'tournament',
    'instant',
];

export const VERTICAL_JP_BADGES = ['bell_link', 'clover_chance', 'gods_kings', 'high_cash', 'vip_bell_link'];

export const HORIZONTAL_JP_BADGES = [
    '20_super_hot',
    '40_super_hot',
    'burning_hot',
    'instantlink',
    'rise_of_ra',
    'versailles_gold',
];

/**
 * There is a request to show games from the same jackpot group with different jp badge
 * Since there is no info for that in the BE response (all games come with the same JP name)
 * we have to hardcode the games and their corresponding badges
 */
export const GAMES_WITH_CUSTOM_BADGES: { [key: string]: string } = {
    GAGKLSlot: 'gods_and_kings',
    ALGKLSlot: 'gods_and_kings',
    RORGKLSlot: 'gods_and_kings',
    OGGKLSlot: 'gods_and_kings',
};

export const bgSectionColor = {
    high_cash: 'rgb(65, 23, 95)',
    vip_high_cash: 'rgb(65, 23, 95)',
    bell_link: 'rgb(26, 0, 0)',
    vip_bell_link: 'rgb(25, 25, 26)',
    clover_chance: 'rgb(19, 60, 20)',
    mystery: 'rgb(19, 60, 20)',
    progressive: 'rgb(139, 45, 3)',
    tournament: 'rgb(60, 0, 16)',
    instant: 'rgb(16, 10, 49)',
};

const constants = {
    FETCH_JP_STAT_INTERVAL_SECONDS,
    FETCH_GAMES_CURRENT_PLAYER_STAT_INTERVAL_SECONDS,
    JP_STAT_UPDATE_FPS,
    LOCAL_STORAGE_FAVORITE_KEY,
    SEARCH_SECTION_NAME,
    LOBBY_SECTION_NAME,
    FAVORITE_SECTION_NAME,
    WEBPACK_HASH,
    BrandedTournamentImagesMap,
    gamesWithAnimatedBanners,
    sectionsWithBgImages,
    bgSectionColor,
    VERTICAL_JP_BADGES,
    HORIZONTAL_JP_BADGES,
};

export default constants;
